import React from 'react';
import SalesDashboard from '../components/SalesDashboard';

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SalesDashboard />
    </div>
  );
}
